import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e25d236"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "verify-email-container" }
const _hoisted_2 = { class: "verify-email-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mail-icon" }, "✉️")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Verify Your Email", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " To continue using JobBuddy, please verify your email address by clicking the link we sent you. ", -1))
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "success-message"
}

import store from "../store";
import { UserApiService } from "@/services/UserApiService";
import router from "../router";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyEmail',
  setup(__props) {

const isResending = ref(false);
const showResendSuccess = ref(false);

onMounted(() => {
  if (sessionStorage.getItem("redirectToDashboard") === "true") {
    sessionStorage.removeItem("redirectToDashboard");
    router.push({ name: "Subscribe" });
  }
});

async function resendVerificationEmail() {
  try {
    isResending.value = true;
    store.dispatch("toggleLoader", true);
    await UserApiService.resendVerificationEmail();
    showResendSuccess.value = true;
    setTimeout(() => {
      showResendSuccess.value = false;
    }, 3000);
  } catch (error) {
    console.error("Error sending verification email:", error);
  } finally {
    isResending.value = false;
    store.dispatch("toggleLoader", false);
  }
}

async function reloadPage() {
  sessionStorage.setItem("redirectToDashboard", "true");
  window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "action-button primary",
          onClick: resendVerificationEmail,
          disabled: isResending.value
        }, [
          (!isResending.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Resend Verification Email"))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, "Sending..."))
        ], 8, _hoisted_7),
        _createElementVNode("button", {
          class: "action-button secondary",
          onClick: reloadPage
        }, "I've Verified My Email")
      ]),
      (showResendSuccess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " ✓ Verification email sent successfully! "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})